import React from "react";

export const CookieSettings = () => {
  return (
    <h1 className="text-green m-t-100 p-t-100 p-b-100">Our Cookie Settings page will be coming soon!</h1>
  );
}

export default CookieSettings;